import AppLayout from '@/layout/AppLayout.vue'
import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: AppLayout,
            children: [
                {
                    path: '/',
                    name: 'dashboard',
                    component: () => import('../views/DashboardView.vue')
                },
                {
                    path: '/service/:serviceName',
                    name: 'service-detail',
                    component: () => import('../views/ServiceDetailView.vue'),
                    props: true
                },
                {
                    path: '/canaries',
                    name: 'canaries',
                    component: () => import('../views/CanariesView.vue')
                }
            ]
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: '/'
        }
    ]
})

export default router
